import http from '../../http-common';
import ProductColoplast from '../../telas/Product/ProductColoplast';


const url = '/Autocomplete/';

export const DefaultAutocompleteService = {
    GetProfileListAutoComplete() {
        return http.get(`${url}Profile`)
    },
    GetMenuAutocomplete(data) {
        return http.post(`${url}Menu`, data)
    },
    GetSystemParameterListAutoComplete() {
        return http.get(`${url}SystemParameter`)
    },
    GetCountryAutocomplete() {
        return http.get(`${url}Country`)
    },
    GetStateAutocomplete() {
        return http.get(`${url}State`)
    },
    GetCityAutocomplete() {
        return http.get(`${url}City`)
    },
    GetUserAutocomplete() {
        return http.get(`${url}User`)
    },
    GetStoreAutocomplete() {
        return http.get(`${url}Store`)
    },
    GetInventoryStockLocation() {
        return http.get(`${url}StockLocationDescriptionList`)
    },
    GetSeparatorFileTemplate() {
        return http.get(`${url}SeparatorFileTemplate`)
    },
    GetClient() {
        return http.get(`${url}Client`)
    },
    GetClientLessGeneric() {
        return http.get(`${url}ClientLessGeneric`)
    },
    GetClientGeneric() {
        return http.get(`${url}ClientGeneric`)
    },
    GetPrinter() {
        return http.get(`${url}Printer`)
    },
    GetPrinterClient() {
        return http.get(`${url}PrinterClient`)
    },
    GetProductNameUfi() {
        return http.get(`${url}ProductNameUfi`)
    },
    GetProductUfi() {
        return http.get(`${url}ProductUfi`)
    },
    GetProductColoplast() {
        return http.get(`${url}ProductColoplast`)
    },
    GetProductGeneric() {
        return http.get(`${url}ProductGeneric`)
    },
    GetPrintQuery() {
        return http.get(`${url}PrintQuery`)
    },
    GetColumnName() {
        return http.get(`${url}ColumnName`)
    },
    GetLocationStock(data) {
        return http.post(`${url}LocationStock`, data)
    },
    GetCollector(data) {
        return http.get(`${url}GetCollector`, data)
    },
    GetProductGroupListAutoComplete(data) {
        return http.get(`${url}ProductGroup`, data)
    },
    GetProfileAutoComplete(data) {
        return http.get(`${url}Profile`, data)
    },
    GetUserAutoComplete(data) {
        return http.get(`${url}User`, data)
    },
    GetPermissionTypeAutoComplete(data) {
        return http.get(`${url}PermissionType`, data)
    },
    GetStorageAutoComplete(data) {
        return http.get(`${url}Storage`, data)
    },
    GetStreetAutoComplete(data) {
        return http.get(`${url}Street`, data)
    },
    GetColumnAutoComplete(data) {
        return http.get(`${url}Column`, data)
    },
    GetLevelAutoComplete(data) {
        return http.get(`${url}Level`, data)
    },
    GetProductMotul(data) {
        return http.get(`${url}ProductMotul`, data)
    },
    GetLayoutEtiquetaMotul(data) {
        return http.get(`${url}LayoutEtiquetaMotul`, {
            params: { idClient: data }
        })
    }
};
